var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabilityMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10804",
    "data-name": "Grupo 10804",
    transform: "translate(1461 -186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-laptop-medical",
    "data-name": "Icon awesome-laptop-medical",
    d: "M7.25,7H9V8.75A.25.25,0,0,0,9.25,9h1.5A.25.25,0,0,0,11,8.75V7h1.75A.25.25,0,0,0,13,6.75V5.25A.25.25,0,0,0,12.75,5H11V3.25A.25.25,0,0,0,10.75,3H9.25A.25.25,0,0,0,9,3.25V5H7.25A.25.25,0,0,0,7,5.25v1.5A.25.25,0,0,0,7.25,7ZM18,1.5A1.5,1.5,0,0,0,16.5,0H3.5A1.5,1.5,0,0,0,2,1.5V12H18ZM16,10H4V2H16Zm3.5,3H11.923A.985.985,0,0,1,10.9,14H9a1.062,1.062,0,0,1-1.024-1H.5a.5.5,0,0,0-.5.5V14a2.006,2.006,0,0,0,2,2H18a2.006,2.006,0,0,0,2-2v-.5A.5.5,0,0,0,19.5,13Z",
    transform: "translate(-1456 192.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17738",
    "data-name": "Rect\\xE1ngulo 17738",
    width: 30,
    height: 30,
    transform: "translate(-1461 186)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabilityMenu);
export default __webpack_public_path__ + "static/media/disability-menu.3be05fabc385853ef5dc72f89b9f123b.svg";
export { ForwardRef as ReactComponent };